import React from "react";
import ReactDOM from "react-dom/client";

// Self-hosted Inter (variable, full weight axis) — the only font used app-wide.
// `.css` path so the side-effect import matches vite/client's `*.css` ambient
// module (required under `noUncheckedSideEffectImports`).
import "@fontsource-variable/inter/index.css";
import "@/styles/globals.css";

import App from "./App.tsx";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in index.html");

ReactDOM.createRoot(rootEl).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
